import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import IconHeart from 'components/icons/iconHeart';
import { colorGrayLight3, colorRed } from 'styles/layout/colors';
import useProductFavoriteV2 from 'data-hooks/useProductFavoriteV2';
import usePDPWishlistEvents from 'data-hooks/useProductFavoriteV2/usePDPWishlistEvents';
const PDPFavoriteButton = () => {
  const $ = _c(17);
  const {
    isFavorited,
    onFavClick
  } = useProductFavoriteV2();
  const {
    productWishlistEvent
  } = usePDPWishlistEvents();
  let t0;
  if ($[0] !== isFavorited || $[1] !== onFavClick || $[2] !== productWishlistEvent) {
    t0 = event => {
      onFavClick(event);
      productWishlistEvent(isFavorited);
    };
    $[0] = isFavorited;
    $[1] = onFavClick;
    $[2] = productWishlistEvent;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleOnFavClick = t0;
  const t1 = !isFavorited;
  let t2;
  if ($[4] !== isFavorited || $[5] !== t1) {
    t2 = classNames("w-9 h-9 rounded-full flex items-center justify-center", {
      "bg-red": isFavorited,
      "bg-gray-light9 hover:bg-gray-light8": t1
    });
    $[4] = isFavorited;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isFavorited) {
    t3 = classNames("w-[0.875rem] ", {
      "animate-heartbeat": isFavorited
    });
    $[7] = isFavorited;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = isFavorited ? colorRed : colorGrayLight3;
  const t5 = isFavorited ? "white" : colorGrayLight3;
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <IconHeart className={t3} color={t4} fill={t5} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== handleOnFavClick || $[14] !== t2 || $[15] !== t6) {
    t7 = <button type="button" data-xc="PDPFavoriteButton" className={t2} onClick={handleOnFavClick}>{t6}</button>;
    $[13] = handleOnFavClick;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default PDPFavoriteButton;